import { useState, useCallback } from "react"
import { useDispatch } from "react-redux"
import { deleteQuestionnaireTemplate, getQuestionnaireTemplates, duplicateQuestionnaireTemplate } from "store/question"
import { toaster } from "components/common/Toast"

export const useTemplateActions = (id, status, onEdit) => {
    const dispatch = useDispatch()
    const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false)
    const [isDeleting, setIsDeleting] = useState(false)

    const handleEditClick = useCallback(
        (e, template) => {
            e.stopPropagation()
            onEdit?.(template)
        },
        [onEdit]
    )

    const handleDuplicate = useCallback(
        (e) => {
            e?.stopPropagation()
            dispatch(duplicateQuestionnaireTemplate(id))
                .then((res) => {
                    dispatch(getQuestionnaireTemplates())
                    toaster.success(res.message)
                })
                .catch((err) => toaster.error(err.message))
        },
        [dispatch, id]
    )

    const handleDelete = useCallback((e) => {
        e?.stopPropagation()
        setIsDeleteModalVisible(true)
    }, [])

    const handleDeleteConfirm = useCallback(async () => {
        try {
            setIsDeleting(true)
            const result = await dispatch(deleteQuestionnaireTemplate(id))
            if (result.message) {
                toaster.success(result.message)
            }
            dispatch(getQuestionnaireTemplates(1, 10, status, ""))
            setIsDeleteModalVisible(false)
        } catch (error) {
            console.error(error)
        } finally {
            setIsDeleting(false)
        }
    }, [dispatch, id, status])

    const handleDeleteCancel = useCallback(() => {
        setIsDeleteModalVisible(false)
    }, [])

    const handleMenuClick = useCallback(
        ({ key }) => {
            switch (key) {
                case "duplicate":
                    handleDuplicate()
                    break
                case "delete":
                    handleDelete()
                    break
                default:
                    break
            }
        },
        [handleDuplicate, handleDelete]
    )

    return {
        isDeleteModalVisible,
        isDeleting,
        handleEditClick,
        handleDuplicate,
        handleDelete,
        handleDeleteConfirm,
        handleDeleteCancel,
        handleMenuClick
    }
}
